import { constants, typographyStyles } from "@newsela/angelou";

import { greyDarkWithOpacity } from "@/angelouCE/utils/constants";

const { heading6Obj, textMObj } = typographyStyles;

const greyDark = constants.colors.ui.neutral[600];

const { colors } = constants;

export const rootCss = {
  display: "flex",
  alignItems: "center",
  backgroundColor: colors.ui.neutral[25],
  borderRadius: "4px",
  color: colors.ui.neutral[500],
  margin: "8px 0",
  padding: "8px 8px 8px 16px",
  width: "100%",
  listStyleType: "none",

  "&:hover": {
    backgroundColor: greyDarkWithOpacity,
    cursor: "pointer",
  },
};

export const iconCss = {
  currentColor: colors.ui.neutral[500],
  height: "32px",
  justifyContent: "center",
  marginLeft: "auto",
  padding: "8px 11px",
  width: "32px",
};

export const optionCss = {
  textAlign: "left",
};

export const titleCss = {
  ...heading6Obj,
  margin: "8px 0",
  color: greyDark,
  fontWeight: "bold",
};

export const detailCss = {
  ...textMObj,
  margin: 0,
  lineHeight: "24px",
  listStyleType: "none",
  padding: 0,
};
